export default "__VITE_ASSET__8e114fb6__"